const endTermRoute = {
  path: 'provider',
  component: () => import('@/views/provider/end-term-management/Wrapper.vue'),
  children: [
    {
      path: '/provider/end-term',
      name: 'endTerm',
      component: () => import('@/views/provider/end-term-management/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.provider.endterm'],
        },
      },
    },
  ],
};

export default endTermRoute;
